import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { PureFooter } from "./pure-footer";
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews";

const query = graphql`
  query Footer {
    prismicFooter {
      _previewable
      data {
        logo {
          url
          alt
          dimensions {
            width
            height
          }
        }
        logo_mark {
          url
          alt
          dimensions {
            width
            height
          }
        }
        brand_description
        social_media_links {
          social_media_icon {
            url
            alt
            dimensions {
              width
              height
            }
          }
          social_media_link {
            url
            target
          }
        }
        certifications {
          label
          link {
            url
            target
          }
          icon {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
        copyright
        body {
          ... on PrismicFooterDataBodySection {
            id
            primary {
              section_title
              section_content {
                richText
              }
            }
            items {
              title
              link {
                url
                target
              }
            }
          }
        }
      }
    }
    emissions {
      total_lbs
    }
  }
`;

export default function FooterRender() {
  const staticData = useStaticQuery(query);

  return <PureFooter data={useMergePrismicPreviewData(staticData)} />;
}
